import React from "react";
import H4 from "../../components/Titles/h4";
import DescriptionSplit from "../../components/Description/description-split";

const PopupService = ({ isOpen, onClose, content }) => {
    if (!isOpen) return null; // Don't render if the popup is closed

    const handleOutsideClick = (e) => {
        // Close the popup if the click is outside the popup content
        if (e.target === e.currentTarget) {
            onClose();
        }
    };

    return (
        <div
            className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50 p-4 sm:p-6 md:p-8"
            onClick={handleOutsideClick}
        >
            <div className="bg-white p-4 sm:p-6 md:p-8 rounded-lg shadow-lg w-full max-w-sm sm:max-w-md md:max-w-lg lg:max-w-xl overflow-y-auto max-h-[90vh]">
                <div className="flex justify-between items-center mb-4">
                    <H4
                        title={content.title}
                        theme="main"
                        fontWeight="semibold"
                        className="text-lg sm:text-xl md:text-2xl"
                    />
                    <button
                        onClick={onClose}
                        className="text-gray-600 hover:text-gray-900 text-xl font-bold focus:outline-none"
                    >
                        &times;
                    </button>
                </div>

                <DescriptionSplit description={content.content} opacity="100" />

                <div className="mt-4 text-right">
                    <button
                        onClick={onClose}
                        className="bg-main text-white px-4 py-2 text-sm sm:text-base md:text-lg rounded-md hover:bg-primary focus:outline-none"
                    >
                        Fermer
                    </button>
                </div>
            </div>
        </div>
    );
};

export default PopupService;